
export default function Benefits() {
  const benefits = [
    {
      icon: 'ri-tools-line',
      title: 'Tecnología moderna',
      description: 'Equipos de última generación para trabajos eficientes y precisos'
    },
    {
      icon: 'ri-search-eye-line',
      title: 'Estudio geofísico',
      description: 'Análisis profesional del terreno para garantizar resultados óptimos'
    },
    {
      icon: 'ri-water-flash-line',
      title: 'Pozos profundos',
      description: 'Perforaciones de alta calidad con estándares de seguridad'
    },
    {
      icon: 'ri-medal-line',
      title: 'Experiencia comprobada',
      description: 'Años de trayectoria en proyectos residenciales, agrícolas e industriales'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Atención rápida',
      description: 'Respuesta inmediata y soluciones adaptadas a tus necesidades'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Garantía de trabajo',
      description: 'Respaldamos la calidad de nuestros servicios con garantía'
    }
  ];

  return (
    <section className="py-10 sm:py-16 lg:py-20 bg-gradient-to-b from-white to-blue-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 sm:mb-12 lg:mb-16">
          <h2 className="text-2xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-2 sm:mb-4">
            ¿Por qué elegirnos?
          </h2>
          <p className="text-sm sm:text-lg md:text-xl text-gray-600 max-w-3xl mx-auto">
            Líderes en soluciones de perforación acuífera con tecnología de punta
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-6 lg:gap-8">
          {benefits.map((benefit, index) => (
            <div 
              key={index}
              className="bg-white p-4 sm:p-6 lg:p-8 rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-1 border border-gray-100"
            >
              <div className="w-10 h-10 sm:w-14 sm:h-14 lg:w-16 lg:h-16 bg-gradient-to-br from-blue-500 to-blue-600 rounded-lg flex items-center justify-center mb-3 sm:mb-5">
                <i className={`${benefit.icon} text-lg sm:text-2xl lg:text-3xl text-white`}></i>
              </div>
              <h3 className="text-sm sm:text-lg lg:text-xl font-bold text-gray-900 mb-1 sm:mb-2 leading-tight">
                {benefit.title}
              </h3>
              <p className="text-xs sm:text-sm lg:text-base text-gray-600 leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
